import {
    getList as _getList,
    getAll as _getAll,
    add as _add,
    update as _update,
    deleteAll as _deleteAll,
} from "../../api";
import { timeToString } from "utils/dateUtils";

const BASE_URL = "/settings/business-hours";
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "id",
    orderDirection: "desc",
    pageNumber: 0,
    pageSize: 5,
};

function normalizeData(data) {
    return data.map((d) => {
        const startTime = new Date(new Date().setHours(d.startTimeHours, d.startTimeMinutes, 0));
        const endTime = new Date(new Date().setHours(d.endTimeHours, d.endTimeMinutes, 0));

        return {
            ...d,
            startTime,
            endTime,
            startTimeString: timeToString(startTime),
            endTimeString: timeToString(endTime),
        };
    });
}


export function getAll({ onSuccess, onError }) {
    _getAll({ url: BASE_URL, onSuccess, onError, normalizer: normalizeData });
}

export function getList({ onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({ url: BASE_URL, data, onSuccess, onInfo, onError, normalizer: normalizeData });
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export function deleteAll({ ids, onSuccess, onError }) {
    _deleteAll({ url: BASE_URL, data: { ids }, onSuccess, onError });
}